import courseSelectionData from './course-selection-content.json';
import type { CourseSelectionContent } from './types';

export * from './types';

export const courseSelectionContent = courseSelectionData as CourseSelectionContent;
